module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (130).516eefdf.jpg";